import React, { useEffect, useMemo, useState } from 'react';
import { Balloon, Button, Form, Input, Overlay, Tag, Tab, Loading } from '@alifd/next';
import { history } from 'ice';
import LzMsg from '@/components/common/LzMessage';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import moment from 'moment';
import TagMapping from './components/TagMapping';
import TagMappingCrowd from './components/TagMappingCrowd';
import utils from '@/common/utils';

const CrowdTag = ({ match }) => {
  // 格式化默认人群名称里的时间
  const formatDateFun = (value) => {
    const date = new Date(value);
    let MM:any = date.getMonth() + 1;
    MM = MM < 10 ? (`0${MM}`) : MM;
    let d:any = date.getDate();
    d = d < 10 ? (`0${d}`) : d;
    let h:any = date.getHours();
    h = h < 10 ? (`0${h}`) : h;
    let m:any = date.getMinutes();
    m = m < 10 ? (`0${m}`) : m;
    let s:any = date.getSeconds();
    s = s < 10 ? (`0${s}`) : s;
    return `默认创建${MM}月${d}日${h}时${m}分${s}秒`;
  };
  // 生成人群所需填写的人群信息
  const [crowdInfo, setCrowdInfo] = useState({
    name: formatDateFun(new Date()),
    description: moment().format('YYYY MM月DD日创建人群').toString().split(' ')[1],
  });
  // 人群预估出的人数
  const [crowdNum, setCrowdNum] = useState(0);

  // 人群标签，左侧渲染的所有标签
  const [tagList, setTagList] = useState([]);
  // 选中标签生成的结构，即右侧展示的内容
  const [activeTagList, setActiveTag] = useState([]);
  // 处理完成后的中间taglist的副本（便于点击左边tag更换中间内容）
  const [tempTagList, setTempTagList] = useState([]);
  // 是否已进行人群预估
  const [estimateStatu, setEstimateStatu] = useState(false);
  // 是否创建成功
  const [createSucc, setCreateSucc] = useState(false);
  // 已选择标签
  const [checkedTags, setCheckedTags] = useState([]);
  // 当前所选中的总分类label
  const [currentKey, setCurrentKey] = useState(0);
  // 最左边的总分类标签
  const [leftGroupList, setLeftGroupList] = useState([]);
  // 中间的分类标签
  const [middleGroupList, setMiddleGroupList] = useState([]);
  // 接口请求时间较长，需要加loading
  const [isLoading, setIsLoading] = useState(true);

  /**
   * 人群预估
   */
  const estimateFun = () => {
    try {
      const bodyParam = checkFun();
      Servlets('crowdEstimate', bodyParam).then((res:any) => {
        if (res.success) {
          setCrowdNum(res.data);
          setEstimateStatu(true);
          LzMsg.success('预估成功', '');
          setIsLoading(false);
        } else {
          LzMsg.error(res.resp_msg);
          setIsLoading(false);
        }
      });
    } catch (e) {
      LzMsg.error(e.message, '');
      setIsLoading(false);
    }
  };

  /**
   * 人群创建
   */
  const createFun = () => {
    try {
      const bodyParam = checkFun();
      Servlets('createCrowd', bodyParam).then((res:any) => {
        if (res.success) {
          setTimeout(() => {
            history.push('/CustomerManagement');
          }, 3000);
          setIsLoading(false);
          setCreateSucc(true);
        } else {
          LzMsg.error(res.resp_msg);
          setIsLoading(false);
        }
      });
    } catch (e) {
      LzMsg.error(e.message);
      setIsLoading(false);
    }
  };

  /**
   * 进行人群预估和保存之前的校验方法
   */
  const checkFun = () => {
    setIsLoading(true);
    const arr = [...activeTagList];
    if (!activeTagList.length && !selectedCrowdList.length) {
      throw new Error('请先选择标签');
    }
    if (crowdInfo.name) {
      const bodyParam = { // 先写出一个基本结构体
        peopleName: crowdInfo.name,
        peopleDescription: crowdInfo.description,
        mergeType: 0, // 合并类型 0-交 1-并 2-差
        peopleList: [],
      };
      try {
        // console.log(activeTagList);
        arr.forEach((contItem:any, contIndex) => {
          contItem.crowdLabels.forEach((item, index) => {
            item.crowdLabels.forEach((subItem, subIndex) => {
              if (subItem.opValue) {
                // 单选类型 subItem?.opValue?.param_list不能为空，subItem?.opValue?.param_list[0].param_id不能为空
                // if(subItem.labelType === '1' && !subItem?.opValue?.param_list[0].param_id) {
                //   throw new Error(`${subItem.labelDescription}标签不能为空`);
                // }
                if (subItem.labelType === '1' && subItem?.opValue?.param_list[0]?.param_id?.length <= 0) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // 多选类型
                if (subItem.labelType === '2' && subItem?.opValue?.param_list[0]?.param_id?.length <= 0) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // 地区类型
                if (subItem.labelType === '3' && subItem?.opValue?.param_list?.length <= 0) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // 滑动类型整数值
                if (subItem.labelType === '4' && !subItem?.opValue?.extra_map[0]?.slider) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // 区间值类型
                // 判断介于大于小于这个类型选没选
                if (subItem.labelType === '5' && subItem?.opValue?.param_list?.length <= 0) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // extra_map的max_price和min_price是否为空
                if (subItem.labelType === '5' && subItem.opType === 'RANGE' && !subItem?.opValue?.extra_map?.max_price) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                if (subItem.labelType === '5' && subItem.opType === 'RANGE' && !subItem?.opValue?.extra_map?.min_price) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                if (subItem.labelType === '5' && subItem.opType !== 'RANGE' && !subItem?.opValue?.extra_map?.price) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // extra_map的max_price和min_price大小关系
                if (subItem.labelType === '5' && Number(subItem?.opValue?.extra_map?.max_price) < Number(subItem?.opValue?.extra_map?.min_price)) {
                  throw new Error(`${subItem.labelDescription}标签范围填写有误`);
                }
                // 日期区间类型
                if (subItem.labelType === '6' && (!subItem?.opValue?.extra_map || subItem?.opValue?.extra_map?.date?.length <= 0)) {
                  throw new Error(`${subItem.labelDescription}标签范围填写有误`);
                }
                if (subItem.labelType === '6' && subItem?.opValue?.extra_map?.date?.every(item => !item)) {
                  throw new Error(`${subItem.labelDescription}标签范围填写有误`);
                }
                if (subItem.labelType === '6' && Number(subItem?.opValue?.extra_map?.date[1]) < Number(subItem?.opValue?.extra_map?.date[0])) {
                  throw new Error(`${subItem.labelDescription}标签范围填写有误`);
                }
                // 品类类型
                if (subItem.labelType === '7' && subItem?.opValue?.param_list?.length <= 0) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // 人群包类型
                if (subItem.labelType === '8' && !subItem?.opValue?.extra_map?.source_audience_id) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                // 购买过商品类型
                if (subItem.labelType === '9' && !subItem?.opValue?.param_list[0]?.param_id?.length) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }
                if (subItem.labelType === '9' && subItem?.opValue?.param_list[0]?.sub_param_list?.length <= 0) {
                  throw new Error(`${subItem.labelDescription}标签不能为空`);
                }

                // 由于现在所有类型都不符合，所以暂时不加校验
                // if (['ALL', 'LT', 'GT', 'LE', 'GE', 'EQ', 'RELLT', 'RELGT', 'RELLE', 'RELGE', 'RELEQ'].includes(subItem.opType)) { // 多选枚举类型单选类型校验
                //   if (subItem.opValue.length <= 0) {
                //     throw new Error(`${subItem.labelDescription}标签不能为空`);
                //   }
                // }
                // if (['RELRANGE', 'RANGE', 'RANGEGT', 'RANGELT'].includes(subItem.opType)) {

                //   // 区间类型校验范围
                //   if (subItem.opValue.length <= 0) {
                //     throw new Error(`${subItem.labelDescription}标签不能为空`);
                //   }
                //   if (subItem.opValue.some((item) => !item )|| (Number(subItem.opValue[0]) === 0 && Number(subItem.opValue[1]) === 0 )) {
                //     throw new Error(`${subItem.labelDescription}标签不能为空`);
                //   }
                //   if (Number(subItem.opValue[1]) < Number(subItem.opValue[0])) {
                //     throw new Error(`${subItem.labelDescription}标签范围填写有误`);
                //   }
                // }
                // if (subItem.opType === 'UNION') { // 省市特殊类型校验
                //   if (subItem.opValue.filter((item) => item.opValue.length <= 0)) {
                //     throw new Error(`${subItem.labelDescription}标签不能为空`);
                //   }
                // }

                const obj = {
                  labelName: subItem.labelName,
                  labelType: subItem.labelType,
                  labelDescription: subItem.labelDescription,
                  opType: subItem.opType,
                  opValue: subItem.opValue,
                };
                bodyParam.peopleList.push(obj);
              } else {
                throw new Error(`${subItem.labelDescription}标签不能为空`);
              }
            });
          });
        });
        selectedCrowdList?.forEach((item) => {
          const obj = {
            labelType: 8,
            opValue: {
              label_id: '46',
              extra_map: {
                source_audience_id: item.crowdId,
                source_audience_name: item.name,
                source_audience_desc: item.description
              }
            }
          };
          bodyParam.peopleList.push(obj);
        });
        return bodyParam;
      } catch (e) {
        throw e;
      }
    } else if (!crowdInfo.name) {
      throw new Error('人群名称不能为空');
    }
    // else if (!crowdInfo.description) {
    //   throw new Error('人群描述不能为空');
    // }
  };

  /**
   * @description: 创建时点击选择一个标签，或者复制时反显所选标签
   * @param {*} activeTagArr 右侧选中数组的一个深拷贝结果，改变这个数组，最后赋值给右侧选中数组
   * @param {*} contItem 一维数据
   * @param {*} contIndex 一维索引
   * @param {*} item 二维数据
   * @param {*} index 二维索引
   * @param {*} subItem 三维数据
   * @param {*} subIndex 三维索引
   * @return {*} activeTagArr 是处理好的右侧选中内容
   */
  const changeTagTrue = (activeTagArr, contItem, contIndex, item, index, subItem, subIndex) => {
    const tip1 = activeTagArr.findIndex((value) => value.labelDescription === contItem.labelDescription); // 判断这条数据的类型是否存在右侧渲染数组里，其一维索引是几
    let tip2 = -1;
    if (tip1 != -1) {
      tip2 = activeTagArr[tip1].crowdLabels.findIndex((value) => value.labelDescription === item.labelDescription); // 其二维索引是几
    }
    if (tip1 !== -1) { // 如果这条数据在右侧渲染数组里，直接放进这个类型下面
      if (tip2 != -1) { // 如果有相同的二级分类，放进去，没有就直接push一个
        activeTagArr[tip1].crowdLabels[tip2].crowdLabels.push(subItem);
      } else {
        activeTagArr[tip1].crowdLabels.push({
          tempIndex: index,
          labelDescription: item.labelDescription,
          crowdLabels: [
            {
              ...subItem,
              tempIndex: subIndex,
            },
          ],
        });
      }
    } else { // 如果没有需要新加出来一个类型
      activeTagArr.push({
        tempIndex: contIndex, // 为了方便删除时在中间列数组中找到对应索引，每次push时加一个index进去
        labelDescription: contItem.labelDescription,
        crowdLabels: [{
          tempIndex: index, // 索引同理
          labelDescription: item.labelDescription,
          crowdLabels: [
            {
              ...subItem,
              tempIndex: subIndex, // 索引同理
            },
          ],
        }],
      });
    }
    return activeTagArr;
  };

  /**
   * @description: 点击左侧标签新增一条右侧对应选框内容
   * @param {*} contItem 一维的数组内容
   * @param {*} contIndex 一维索引
   * @param {*} item 二维的数组内容
   * @param {*} index 二维索引
   * @param {*} subItem 三维的数组内容
   * @param {*} subIndex 三维索引
   * @param {*} source 操作来源，isMiddleClick-证明是点击中间数组（这个是为了在取消选中时，针对数组索引不同处理）
   * @return {*}
   */
  const createTag = (contItem, contIndex, item, index, subItem, subIndex, source = '') => {
    // 每次获取最新的中间和右侧渲染数组，处理这个变量，最后再赋值回去
    let activeTagArr = JSON.parse(JSON.stringify(activeTagList));
    const tagArr = JSON.parse(JSON.stringify(tempTagList));
    if (subItem.status) { // 如果已选，取消选择，右侧渲染数组中删除这条数据
      tagArr[contItem.tempIndex].crowdLabels[item.tempIndex].crowdLabels[subItem.tempIndex].status = false; // 改变中间渲染数据的选中状态

      // 针对点击右侧的组件或者中间展示数组进行取消，索引是不同的
      const tip1 = source === 'isMiddleClick' ? activeTagArr.findIndex((item) => item.tempIndex === contIndex) : contIndex;
      const tip2 = source === 'isMiddleClick' ? activeTagArr[tip1].crowdLabels.findIndex((item) => item.tempIndex === index) : index;
      const tip3 = source === 'isMiddleClick' ? activeTagArr[tip1].crowdLabels[tip2].crowdLabels.findIndex((item) => item.tempIndex === subIndex) : subIndex;
      activeTagArr[tip1].crowdLabels[tip2].crowdLabels.splice(tip3, 1); // 把右侧选中的组件删掉

      if (activeTagArr[tip1].crowdLabels[tip2].crowdLabels.length === 0) {
        activeTagArr[tip1].crowdLabels.splice(tip2, 1); // 如果二级分类的内容都删掉了，就把这个二级分类也删掉
      }
      if (activeTagArr[tip1].crowdLabels.length === 0) {
        activeTagArr.splice(tip1, 1); // 如果一级分类的内容都删掉了，就把这个一级分类也删掉
      }
    } else { // 未选就添加进去
      if (getActiveListNum >= 10) {
        LzMsg.error('所选标签数不能超过10个');
        return;
      }
      const pushIndex = currentKey === 0 ? contIndex : currentKey - 1; // 原因同上

      // 改变中间缓存渲染数据的选中状态，为方便后续的取消选中，给每一分类加上tempIndex
      tagArr[pushIndex] = {
        ...tagArr[pushIndex],
        tempIndex: contIndex,
      };
      tagArr[pushIndex].crowdLabels[index] = {
        ...tagArr[pushIndex].crowdLabels[index],
        tempIndex: index,
      };
      tagArr[pushIndex].crowdLabels[index].crowdLabels[subIndex] = {
        ...tagArr[pushIndex].crowdLabels[index].crowdLabels[subIndex],
        tempIndex: subIndex,
        status: true,
      };

      // 为右侧渲染的数组准备数据
      subItem.opType = ''; // 本个标签的操作符类型，区间、大于、小于等等，参考同级文件tagSaveDemo.json
      subItem.opValue = null; // 这个标签选的值
      subItem.status = true; // 选中状态，置为true
      subItem.tempIndex = subIndex; // 加一个针对于整个大数组的索引，方便后续的删除
      activeTagArr = changeTagTrue(activeTagArr, contItem, contIndex, item, index, subItem, subIndex);
    }
    setTempTagList(tagArr); // 把暂存区数据的是否选中状态更新
    setMiddleGroupList(currentKey === 0 ? tagArr : [tagArr[currentKey - 1]]); // 改变中间数组的状态，如果不是0，就要在tagArr里取出对应的那一组分类，并把它变成一个数组的形式
    setActiveTag(activeTagArr);
  };

  /**
   * @description: 改变activeTagList每条数据的selectedValue选中值
   * @param {*} contIndex 一级索引
   * @param {*} index 二级索引
   * @param {*} subIndex 三级索引
   * @param {*} newData 最新改变的那个值
   * @return {*}
   */
  const changeActiveTagValue = (contIndex, index, subIndex, newData) => {
    const arrVal = [...activeTagList];
    Object.assign(arrVal[contIndex].crowdLabels[index].crowdLabels[subIndex], newData);
    setActiveTag(arrVal);
  };

  //
  const returnHtml = (contItem, contIndex) => {
    return (<div key={`middle_group_${contIndex}`} className={`${styles['label-kind']} main-tag`}>
      {
        contItem.crowdLabels.map((item, index) => {
          return (<div key={`middle_group_one_${index}`}>
            <div className={`${styles['second-title']}`}>{item.labelDescription}</div>
            {/* 二级分类名 */}
            {
              item.crowdLabels.map((subItem, subIndex) => {
                return (
                  <Balloon.Tooltip
                    followTrigger
                    align="t"
                    key={`middle_group_two_${subIndex}`}
                    trigger={<Tag.Selectable
                      key={`middle_group_two2_${subIndex}`}
                      checked={subItem.status}
                      onChange={() => createTag(contItem, contIndex, item, index, subItem, subIndex, 'isMiddleClick')}
                      style={{
                        width: '45%',
                        marginLeft: '2.5%',
                        marginTop: '2%',
                      }}
                      className={styles.pointer}
                    >
                      {subItem.labelDescription} {/* 标签名 */}
                    </Tag.Selectable>}
                  >
                    {subItem.labelDescription}
                  </Balloon.Tooltip>
                );
              })
            }
          </div>);
        })
      }
    </div>);
  };
  /**
   * @description: 标签复制
   * @param {*} data 接口查询回来的所有标签
   * @return {*}
   */
  const copyTag = (data) => {
    try {
      const esJson = JSON.parse(sessionStorage.getItem('LzCrowdEsIson')); // 在缓存中取出策略信息
      const obj = {
        name: `${esJson.name}副本` ?? '复制人群策略副本',
        labelDescription: esJson.labelDescription ?? crowdInfo.labelDescription,
      };
      if (obj.name.length >= 32) { // 如果复制过来，名字过长，就强行处理一下
        obj.name = '复制人群策略副本';
      }
      // 给人群名称和描述赋值
      setCrowdInfo({
        ...crowdInfo,
        ...obj,
      });

      // 返显选中标签
      let activeTagArr = JSON.parse(JSON.stringify(activeTagList)); // 深拷贝一个右侧已选数组，准备改变它的值
      data?.forEach((allItem, allIndex) => {
        allItem?.crowdLabels.forEach((contItem, contIndex) => {
          contItem?.crowdLabels.forEach((item, index) => {
            // item.crowdLabels.forEach((subItem, subIndex) => {
            // 判断要复制的人群策略里有没有这个标签
            // console.log(esJson.list)
            esJson?.list?.forEach((esItem, esIndex) => {
              if (esItem.labelName === item.labelName) {
                // item = {
                //   ...item,
                //   status: true,
                //   ...esItem,
                // }
                /** 开始 */
                // 给中间数组赋值，需要把用到的索引和标签状态改好
                item = {
                  ...item,
                  status: true,
                  tempIndex: index,
                  ...esItem,
                };
                contItem.crowdLabels[index] = item;
                contItem = {
                  ...contItem,
                  tempIndex: contIndex,
                };
                data[allIndex].crowdLabels[contIndex] = contItem;
                data[allIndex] = {
                  ...data[allIndex],
                  tempIndex: allIndex,
                };
                /** 结束 */
                activeTagArr = changeTagTrue(activeTagArr, allItem, allIndex, contItem, contIndex, item, index); // 改变右侧选中的数组，往里加一条标签
              }
            });
            // })
          });
        });
      });
      setLeftGroupList([{
        id: 0,
        labelDescription: '全部',
      }, ...data]); // 给左侧标签组赋值
      setTempTagList(data); // 确认中间暂存区所有数据
      setMiddleGroupList(data); // 给中间展示的数组赋值
      setActiveTag(activeTagArr); // 给右侧数组赋值
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      LzMsg.error(e.message);
    }
  };

  /** 设置 Header 面包屑 */
  const setBreadcrumb = () => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '客户管理', // 一级页面名称
      url: '/web/CustomerManagement', // 一级页面url
      children: {
        name: '人群管理', // 二级页面名称
        url: '/web/CustomerManagement', // 二级页面url
        children: {
          name: '标签组合', // 三级页面名称
          url: '', // 三级页面url
        },
      },
    });
  };

  // 获取所有标签
  const getTags = async () => {
    await Servlets('getPublicPeopleTag', {}).then((qwe) => {
      if (qwe.success) {
        const res = qwe.data.tab_list;

        res.forEach(i1 => {
          i1.labelName = i1?.tab_name; // 用户基础属性 == 基础标签
          i1.labelDescription = i1?.tab_name;
          if (i1.sub_tab.length > 0) {
            i1.crowdLabels = i1?.sub_tab?.map(i2 => {
              return {
                labelName: i2?.tab_name, // 基础标签 == 基础属性
                labelDescription: i2?.tab_name,
                crowdLabels: i2?.label_list?.map(i3 => {
                  return {
                    id: i3?.label_id,
                    labelName: i3?.label_name, // 年龄 == 八大人群
                    labelDescription: i3?.label_name,
                    label_desc: i3?.label_desc,
                    labelType: i3?.label_type,
                    valueType: i3?.label_type,
                    value: i3?.param_list?.map(i4 => {
                      return {
                        realValue: i4?.param_id,
                        fieldValue: i4?.param_name,
                        ...i4,
                      }
                    })
                  }
                })
              }
            });
          } else {
            i1.crowdLabels = [{
              labelName: i1?.tab_name, // 基础标签 == 基础属性
              labelDescription: i1?.tab_name,
              crowdLabels: i1?.label_list?.map(i2 => {
                return {
                  labelName: i2?.label_name, // 基础标签 == 基础属性
                  labelDescription: i2?.label_name,
                  crowdLabels: i1?.label_list?.map(i3 => {
                    return {
                      id: i3?.label_id,
                      labelName: i3?.label_name, // 年龄 == 八大人群
                      labelDescription: i3?.label_name,
                      label_desc: i3?.label_desc,
                      labelType: i3?.label_type,
                      valueType: i3?.label_type,
                      value: i3?.param_list?.map(i4 => {
                        return {
                          realValue: i4?.param_id,
                          fieldValue: i4?.param_name,
                        }
                      })
                    }
                  })
                }
              })
            }]
          }
        });
        if (match.params.type === 'create') {
          setLeftGroupList([
            {
              id: 0,
              labelDescription: '全部',
            },
            ...res
          ]);
          setMiddleGroupList(res); // 给初始中间分组的list赋值
          setTempTagList(res); // 把所有分类存起来，这样可以每次点击时直接取这个暂存区的值
          setIsLoading(false);
        } else {
          copyTag(res);
        }
        setTagList(res); // 目前有两种情况，白名单商家具有品类标签，所以返回数据是多条，前端把所有数据暂存一次，方便以后切换用
      } else {
        setIsLoading(false);
        LzMsg.error(qwe.resp_msg);
      }
    });
  };

  /**
   * @description: 点击左边分组，切换中间分组的展示内容
   * @param {*} index 点击的左侧分组的索引值
   * @return {*}
   */
  const clickLeftGroup = (index) => {
    setCurrentKey(index); // 左侧分组高亮切换
    setMiddleGroupList(index === 0 ? tempTagList : [tempTagList[index - 1]]); // 切换中间分组展示的内容,因为左侧分组比中间分组多了一层 ‘全部’，所以索引要+1
  };

  // 人群包相关部分所需的变量。由于没有原型，没有需求统计，只让前端根据抖音官方开发，而抖音文档并没有体现任何人群包类型的特殊性，所以现在只能临时添加一个部分，并且也不再拆分组件，直接累积吧。
  const [officeCrowdInfo, setOfficeCrowdInfo] = useState([]); // 官方推荐人群
  const [diyCrowdInfo, setDiyCrowdInfo] = useState([]); // 自定义人群
  const [crowdCurrentKey, setCrowdCurrentKey] = useState(0); // 当前选中的key
  const [currentShowCrowdInfo, setCurrentShowCrowdInfo] = useState([]); // 当前展示的人群包信息
  const [selectedCrowdList, setSelectedCrowdList] = useState([]); // 当前选中的人群包列表
  // 点击切换官方推荐人群和自定义人群
  const clickCrowdLeftGroup = (key) => {
    setCrowdCurrentKey(key);
    setCurrentShowCrowdInfo(key === 0 ? [...officeCrowdInfo] : [...diyCrowdInfo]);
  };
  // 点击生成新的人群包标签
  const clickCreateNewCrowd = (item, index, action = 'add') => {
    if (action === 'add') {
      if (getActiveListNum >= 10) {
        LzMsg.error('所选标签数不能超过10个');
        return;
      } else {
        const ar = JSON.parse(JSON.stringify(selectedCrowdList));
        ar.push(item);
        setSelectedCrowdList(ar);
      }
    } else {
      const ar = JSON.parse(JSON.stringify(selectedCrowdList));
      ar.splice(index, 1);
      setSelectedCrowdList(ar);
    }
  };
  // 获取所有官方人群和自定义人群
  const getCrowds = async () => {
    await Servlets('getDYCrowdList', {
      pageNo: 1,
      pageSize: 99999,
      type: 3 // 官方人群
    }).then((res) => {
      if (res.success) {
        setOfficeCrowdInfo(res.data);
        setCurrentShowCrowdInfo(res.data);
        // setOfficeCrowdInfo([
        //   {
        //     name: '1',
        //     description: '抖音用户',
        //     id: '1',
        //     type: '1',
        //   },
        //   {
        //     name: '2',
        //     description: '抖音用户',
        //     id: '2',
        //     type: '1',
        //   },
        //   {
        //     name: '3',
        //     description: '抖音用户',
        //     id: '3',
        //   }
        // ])
        // setCurrentShowCrowdInfo([
        //   {
        //     name: '1',
        //     description: '抖音用户',
        //     id: '1',
        //     type: '1',
        //   },
        //   {
        //     name: '2',
        //     description: '抖音用户',
        //     id: '2',
        //     type: '1',
        //   },
        //   {
        //     name: '3',
        //     description: '抖音用户',
        //     id: '3',
        //   }
        // ])
      } else {
        LzMsg.error(res.resp_msg);
      }
    });

    await Servlets('getDYCrowdList', {
      pageNo: 1,
      pageSize: 99999,
      type: '1,2,5,6,8,9,10' // 自定义人群
    }).then((res) => {
      if (res.success) {
        setDiyCrowdInfo(res.data)
      } else {
        LzMsg.error(res.resp_msg);
      }
    });
  };

  /**
   * @description: 每次选择时统计一共选了多少个标签，相关的所有方法
   * @param {*}
   * @return {*}
   */
  let allSelectNum = 0; // 全局存一下一共选了几个标签
  const isArray = (obj) => { // 判断是否是数组类型
    return Object.prototype.toString.call(obj) === '[object Array]';
  };
  const numFun = (source) => {
    for (const i in source) {
      const item = source[i];
      if (isArray(item.crowdLabels)) {
        numFun(item.crowdLabels);
      } else {
        allSelectNum += 1;
      }
    }
  };
  const getActiveListNum = useMemo(() => {
    allSelectNum = 0;
    numFun(activeTagList);
    return allSelectNum + selectedCrowdList.length;
  }, [activeTagList, selectedCrowdList]);

  useEffect(() => {
    setBreadcrumb();
    getTags();
    getCrowds();
  }, []);

  return (
    <div className={`${styles['tag-div']}`}>
      <div className={`${styles['form-box']}`}>
        <Form labelAlign='left' >
          <div style={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div className={`${styles['reactive-box']}`}>
              <div className={`${styles['auto-box']}`} style={{ marginRight: '40px' }}>
                <Form.Item >
                  <span style={{ color: '#fe5957' }}>*</span><span className={styles.mr15}>人群名称:</span>
                  <Input
                    name="人群名称"
                    size="small"
                    maxLength={32}
                    value={crowdInfo.name}
                    onChange={(val) => setCrowdInfo({ ...crowdInfo, name: val })}
                    style={{ width: '350px' }}
                  />
                </Form.Item>
              </div>
              <div className={`${styles['auto-box']}`}>
                <Form.Item >
                  <span className={styles.mr15}>人群描述:</span>
                  <Input
                    name="描述"
                    size="small"
                    maxLength={32}
                    value={crowdInfo.description}
                    onChange={(val) => setCrowdInfo({ ...crowdInfo, description: val })}
                    style={{ width: '350px' }}
                  />
                </Form.Item>
              </div>
              <div className={`${styles['auto-box1']}`}>
                <Form.Item
                  style={{
                    justifyContent: 'flex-end',
                    whiteSpace: 'nowrap',
                    textAlign: 'right',
                  }} >
                  <div >
                    <Button
                      type="primary"
                      className={`${styles.w88} ${styles.mr10}`}
                      onClick={createFun}
                    >保存人群
                    </Button>
                    <Button
                      type="normal"
                      className={`${styles.w88}`}
                      onClick={() => {
                        history.push('/CustomerManagement');
                      }}
                    >返回
                    </Button>
                  </div>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className={`${styles['back-box']} ${styles.mb20}`} >
        <div className={`${styles['calc-number']}`}>
          <div style={{ display: 'flex' }}>
            <div
              className="iconfont icon-chaojiyingxiaoicon_huaban1-02"
              style={{ fontSize: '46px', marginRight: '10px' }}
            />
            <div style={{ fontSize: '18px' }}>总人数：{crowdNum}人</div>
          </div>
          <Button
            type="normal"
            className={`${styles.w88}`}
            style={{ marginTop: '26px', color: '#5D4CFF' }}
            onClick={estimateFun}
          >人数计算
          </Button>
        </div>
      </div>
      <div className={`${styles['back-box']} ${styles['content-container']} ${styles['flex-between-center']}`}>

        <div className={`${styles['label-choose']} middle-div`}>
          <Tab>
            <Tab.Item title="标签选择" key="0">
              <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                {/* 左侧分组结构 */}
                <div className={`${styles.category}`}>
                  {
                    leftGroupList.map((item, index) => {
                      return (<div
                        key={`left_group_${index}`}
                        className={`${styles.ballon}`}
                        style={{
                          border: currentKey === index ? '1px solid #5D4CFF' : '1px solid #D7DDE4',
                          color: currentKey === index ? '#5D4CFF' : 'black',
                        }}
                        onClick={() => {
                          clickLeftGroup(index);
                        }}
                      >
                        {item.labelDescription}
                      </div>);
                    })
                  }
                </div>

                {/* 中间分组结构 */}
                <div className={styles['fixed-height']}>
                  <div className={`${styles['label-container']}`}>
                    {
                      tempTagList.map((contItem, contIndex) => (<div key={`label_${contIndex}`}>
                        {
                          currentKey === 0 ? <> {returnHtml(contItem, contIndex)}</> : <> {contIndex === (currentKey - 1) && returnHtml(contItem, contIndex)} </>
                        }
                      </div>))
                    }
                  </div>
                </div>

              </div>
            </Tab.Item>

            <Tab.Item title="人群包选择" key="1">
              <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                {/* 左侧分组结构 */}
                <div className={`${styles.category}`}>
                  <div
                    className={`${styles.ballon}`}
                    style={{
                      border: crowdCurrentKey === 0 ? '1px solid #5D4CFF' : '1px solid #D7DDE4',
                      color: crowdCurrentKey === 0 ? '#5D4CFF' : 'black',
                    }}
                    onClick={() => {
                      clickCrowdLeftGroup(0);
                    }}
                  >
                    官方人群
                  </div>
                  <div
                    className={`${styles.ballon}`}
                    style={{
                      border: crowdCurrentKey === 1 ? '1px solid #5D4CFF' : '1px solid #D7DDE4',
                      color: crowdCurrentKey === 1 ? '#5D4CFF' : 'black',
                    }}
                    onClick={() => {
                      clickCrowdLeftGroup(1);
                    }}
                  >
                    自定义人群
                  </div>
                </div>

                {/* 中间分组结构 */}
                <div className={styles['fixed-height']}>
                  <div className={`${styles['label-container']}`}>
                    {
                      currentShowCrowdInfo.length > 0 ? <div className={`${styles['label-kind']} main-tag`} style={{ padding: '20px 5px' }}>
                        {
                          currentShowCrowdInfo.map((contItem:any, contIndex) => (
                                <Balloon.Tooltip
                                  followTrigger
                                  align="t"
                                  key={`middle_crowd_group_two_${contIndex}`}
                                  trigger={<Tag.Selectable
                                    key={`middle_crowd_group_two2_${contIndex}`}
                                    checked={selectedCrowdList.indexOf(contItem.id) > -1}
                                    onChange={() => clickCreateNewCrowd(contItem, contIndex)}
                                    style={{
                                      width: '45%',
                                      marginLeft: '2.5%',
                                      marginTop: '2%',
                                    }}
                                    className={styles.pointer}
                                  >
                                    {contItem.name} {/* 标签名 */}
                                  </Tag.Selectable>}
                                >
                                  {contItem.name}
                                </Balloon.Tooltip>
                          ))
                        }</div>
                        : <div>暂无数据</div>
                    }
                  </div>
                </div>

              </div>
            </Tab.Item>
          </Tab>
        </div>

        <div className={`${styles['group-method']}`}>
          <div className={`${styles.title}`}>
            <div>组合公式：组内所有标签为交集</div>
            <div style={{ fontSize: '12px', fontWeight: 500, display: 'flex' }}>
              <div>已选标签：</div>
              <div className={styles.red}>{getActiveListNum}</div>
              {/* <Button text type="primary" style={{marginLeft:"20px"}} onClick={()=>{labelClear()}}>清空</Button> */}
            </div>
          </div>
          {/* 右侧分组结构 */}
          <div className={`${styles['fixed-height']}`}>
            <TagMapping
              activeTagList={activeTagList}
              changeActiveTagValue={changeActiveTagValue}
              changeActiveList={createTag}
            />
            <TagMappingCrowd
              activeTagList={selectedCrowdList}
              changeActiveList={clickCreateNewCrowd}
            />
          </div>
        </div>
      </div>
      <Overlay
        visible={createSucc}
        align="cc cc"
        hasMask
        disableScroll
        canCloseByMask={false}
      >
        <span className="overlay-demo">
          创建人群成功，即将跳转人群管理页面
        </span>
      </Overlay>
      <Loading
        visible={isLoading}
        fullScreen
      />
    </div>
  );
};
export default CrowdTag;
